import type { ConnectorOption } from "@/features/connectors";
import { isCustomConnector } from "@/integrations";

const NAME_STARTS_WITH = 0;
const WORD_STARTS_WITH = 1;
const OTHER_MATCH = 2;
const CUSTOM_CONNECTOR_FALLBACK = 3;

/** How well an option that already matched a search fits it; lower ranks first. */
export function searchRank(option: ConnectorOption, searchText: string) {
  if (isCustomConnectorFallback(option)) return CUSTOM_CONNECTOR_FALLBACK;
  const query = searchText.trim().toLowerCase();
  const name = option.label.toLowerCase();
  if (name.startsWith(query)) return NAME_STARTS_WITH;
  if (name.split(/[^a-z0-9]+/).some((word) => word.startsWith(query))) {
    return WORD_STARTS_WITH;
  }
  return OTHER_MATCH;
}

/** The custom connector, which matches every search, so it only ever comes after the real matches. */
export function isCustomConnectorFallback(option: ConnectorOption) {
  return isCustomConnector(option.value) && !option.isCommunity;
}
